import type React from 'react'
import {AccordionV2, AccordionItemV2} from 'pepsico-ds'
import type {IAccordionItemV2Props, IAccordionV2Props} from 'pepsico-ds'
import './AccordionWrapper.module.css'

interface AccordionWrapperProps extends IAccordionV2Props {
  items: IAccordionItemV2Props[]
}

const AccordionWrapper: React.FC<AccordionWrapperProps> = ({items, ...accordionProps}) => {
  return (
    <AccordionV2 {...accordionProps}>
      {items.map((item, idx) => (
        <AccordionItemV2 key={item.id || `accordion-item-${idx}`} {...item} />
      ))}
    </AccordionV2>
  )
}

export default AccordionWrapper
